import './App.css';
import Home from './component/Home';
import Accomodation from './component/Accomodation';
import React from 'react';
import { ThemeProvider, createTheme, CssBaseline, Box } from '@mui/material';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import MeetingEvents from './component/MeetingEvents';
import ScrollToTopButton from './component/ScrollToTopButton';

function App() {

const theme = createTheme({
  palette: {
    mode:  'dark',
  },
});
  

  return (  
    <>
      
      <ThemeProvider theme={theme} >
      <CssBaseline />
        <Box sx={{ textAlign: 'center',}} >  
        <Router>
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/Home" element={<Home/>} />
              <Route path="/accomodation" element={<Accomodation />} />
              <Route path="/meetingEvents" element={<MeetingEvents />} />
        </Routes>
        </Router>
        
        {/* Scroll-to-Top Button */}
        <ScrollToTopButton />
      </Box>
      </ThemeProvider>
      
    </>
  );
};

export default App;



